module.exports = __webpack_public_path__ + "img/britam.520f46a5.jpg";